// Generated by CoffeeScript 2.7.0
var PayloadItem, SCOPE_OPTIONS, TIME_OPTIONS, TYPE_OPTIONS, select_option_comp;

import Popover from 'trunks/vue/admin/components/libs/popover.js';

import GroupOptions from 'trunks/vue/admin/components/libs/group_options.js';

TYPE_OPTIONS = [
  {
    push_type: 'Push::CustomMessage',
    name: '微信',
    _selected: true
  },
  {
    push_type: 'Push::Sms',
    name: '短信',
    _selected: false
  },
  {
    push_type: 'Push::Call',
    name: '电话',
    _selected: false
  },
  {
    push_type: 'Push::Webhook',
    name: 'Webhook',
    _selected: false
  }
];

TIME_OPTIONS = [
  {
    push_time: 'created',
    name: '到达节点时',
    _selected: true
  },
  {
    push_time: 'updated',
    name: '节点处理时',
    _selected: false
  },
  {
    push_time: 'time_up',
    name: '逾期时',
    _selected: false
  }
];

SCOPE_OPTIONS = [
  {
    push_scope: 'review',
    name: '处理者',
    _selected: true
  },
  {
    push_scope: 'cc',
    name: '抄送者',
    _selected: false
  }
];

select_option_comp = {
  name: 'SelectOption',
  components: {
    'Popover': Popover,
    'group-options': GroupOptions
  },
  props: {
    groupedOptions: {
      type: Array,
      required: true
    },
    attrKey: {
      type: String
    }
  },
  computed: {
    displayValue: function() {
      var name;
      name = '';
      _.map(this.groupedOptions[0].options, function(option) {
        if (option._selected) {
          return name = option.name;
        }
      });
      return name;
    }
  },
  template: `<Popover :blockContent='true'
         customClass='push-popover select'
         position='bottom'
         ref="tagsSelectPopoverRef">
  <template slot='trigger'>
    <div class="input-control justify-box right-addon">
      <div class="controlled-input"
           v-show='displayValue'>
        <slot name="display-item" :displayValue="displayValue">{{ displayValue }}</slot>
      </div>
      <div class="controlled-input placeholder"
           v-show='!displayValue'>请选择</div>
      <div class="addon">
        <i class="slp-caret-down"></i>
      </div>
    </div>
  </template>
  <template slot='content'>
    <group-options :groupedOptions='groupedOptions'
                   :multiple="false"
                   @valueChanged="optionChangeFunc"
                   ref='groupedOptionsRef'>
      <template slot='option-item-template' slot-scope='{ option }'>
        <div class='content'>
          <span>{{ option.name }}</span>
        </div>
        <i class='tip'
           :class="option._selected ? 'slp-check' : 'slp-empty'"></i>
      </template>
    </group-options>
  </template>
</Popover>`,
  methods: {
    optionChangeFunc: function(_vm, option) {
      return this.$emit('optionChanged', option, this.attrKey);
    }
  }
};

export default PayloadItem = Vue.extend({
  components: {
    'SelectOption': select_option_comp
  },
  props: {
    initialPayload: {
      type: Object
    },
    index: {
      type: Number
    }
  },
  data: function() {
    return {
      payload: this.initialPayload,
      minute: this.initialPayload.waiting % 60 || 0,
      webhook: this.initialPayload.webhook_url || ''
    };
  },
  template: `<div class="inline mb-4 form-field-group push-payload">
  <div class="form-field">
    <div class="mt-2">{{ index + 1 }}</div>
  </div>
  <div class="inline form-field">
    <div class="form-field-input-container">
      <div class="form-field-input">
        <SelectOption
          :groupedOptions="groupedTimeOptions"
          attrKey="push_time"
          @optionChanged="pushPayloadChangeFunc"
        />
      </div>
    </div>
  </div>
  <div class="inline form-field">
    <div class="form-field-input-container">
      <div class="form-field-input options">
        <label class="option-item">
          <input type="number"
                 value="0"
                 v-model.number="minute"
                 @focus="focusFunc">
          <span>分钟</span>
        </label>
      </div>
    </div>
  </div>
  <div class="inline form-field">
    <div class="form-field-input-container">
      <div class="form-field-input">
        <SelectOption
          :groupedOptions="groupedTypeOptions"
          attrKey="push_type"
          @optionChanged="pushPayloadChangeFunc"
        />
      </div>
    </div>
  </div>
  <div class="inline form-field">
    <div class="form-field-input-container">
      <div class="form-field-input">
        <input v-if="payload.push_type === 'Push::Webhook'"
               v-model="webhook"
               type="text"
               value="0"
               placeholder="请输入 URL">
        <SelectOption
          v-else
          :groupedOptions="groupedScopeOptions"
          attrKey="push_scope"
          @optionChanged="pushPayloadChangeFunc"
        />
          <div class="chip" slot='display-template' slot-scope='{ displayValue }'>
            {{ displayValue }}
          </div>
        </SelectOption>
      </div>
    </div>
  </div>
  <button class="ml-3 text-btn btn-danger"
          @click="deletePayload">删除</button>

</div>`,
  watch: {
    minute: function(val) {
      this.payload.waiting = this.minute;
      return this.$emit('payloadChanged', this.index, this.payload);
    },
    webhook: function(val) {
      this.payload.webhook_url = val;
      return this.$emit('payloadChanged', this.index, this.payload);
    }
  },
  computed: {
    groupedTypeOptions: function() {
      return [
        {
          allow_clear: false,
          options: this.initOptions(TYPE_OPTIONS,
        'push_type')
        }
      ];
    },
    groupedTimeOptions: function() {
      return [
        {
          allow_clear: false,
          options: this.initOptions(TIME_OPTIONS,
        'push_time')
        }
      ];
    },
    groupedScopeOptions: function() {
      return [
        {
          allow_clear: false,
          options: this.initOptions(SCOPE_OPTIONS,
        'push_scope')
        }
      ];
    }
  },
  methods: {
    pushPayloadChangeFunc: function(option, key) {
      this.payload[key] = option[key];
      return this.$emit('payloadChanged', this.index, this.payload);
    },
    initOptions: function(options, key) {
      return _.map(options, (option) => {
        if (option[key] === this.initialPayload[key]) {
          option._selected = true;
        } else {
          option._selected = false;
        }
        return option;
      });
    },
    focusFunc: function(event) {
      return event.target.select();
    },
    deletePayload: function() {
      return this.$emit('deletedPayload', this.index, this.payload);
    }
  }
});
